const CREATE_ROLE_ROUTE = 12;
const FORM_NAME = "roles";
export { CREATE_ROLE_ROUTE, FORM_NAME };

